<div class="container py-4">

  <!-- 🔷 TÍTULO -->


  <!-- 🟥 BANNER -->
  <div class="banner-ia">
    <div class="banner-left">
      <img src="assets/banners_carreras/ADMIN.jpg" alt="IA">
    </div>
  </div>

  <!-- 📘 INFO PRINCIPAL -->
  <section class="info-section">

    <div class="info-block">
      <h3>■ OBJETIVO GENERAL</h3>
      <p>
       Formar profesionales de la administración comprometidos con las demandas y oportunidades del entorno, con una visión estratégica, humanista y global, que actúen como agentes de cambio, a través del diseño, innovación y dirección en organizaciones
      </p>
    </div>



    <div class="info-block">
      <h3>■ MISIÓN</h3>
      <p>
       Formar profesionales competentes en la administración con visión emprendedora y liderazgo, capaces de innovar, desarrollar e interpretar tendencias de actividades industriales, comerciales y de servicios; especializado en la gestión y dirección de recursos de manera ética, humana y sustentable.
      </p>
    </div>

    <div class="info-block">
      <h3>■ VISIÓN</h3>
      <p>
      Ser la licenciatura en administración más reconocida en la región por el liderazgo de sus egresados y compromiso de sus profesores altamente calificados en la docencia y la investigación; capaces de impulsar proyectos innovadores que contribuyan al desarrollo empresarial y económico del país, con un alto sentido de responsabilidad social, ética y cuidado del medio ambiente.
      </p>
    </div>

  </section>

  <!-- 🧠 TABS -->
  <div class="tabs-box">

    <ul class="nav nav-tabs">
      <li class="nav-item">
        <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab1">
          Perfil de Ingreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2">
          2. Perfil de Egreso
        </button>
      </li>

        <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3">
          3. Acreditación
        </button>
      </li>

<!--       <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab4">
          4. Atributos de Egreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab5">
          5. Acreditación
        </button>
      </li>  -->
    </ul>

    <div class="tab-content">

      <!-- TAB 1 -->
      <div id="tab1" class="tab-pane fade show active">
        <ul>
          <p>El aspirante a la Licenciatura en Administración deberá poseer:</p>
          <p>CONOCIMIENTOS:</p>
         <li>Matemáticas, Contabilidad, Estadística, Administración y Tecnologías de la Información</li>
         <p>HABILIDADES:</p>
         <li>Sociales, de análisis y síntesis, identificación y resolución de problemas, pensamiento creativo, de organización, autocrítica, automotivación, lingüistica, liderazgo, trabajo en equipo, de adaptación, toma de decisiones y manejo de las tecnologías de la información.</li>
         <p>ACTITUDES:</p>
         <li>Proactivo, de conciencia ambiental, inquietud por la investigación aplicada, interés por actividades extraacadémicas, emprendedurismo, interés por la administración, honestidad, responsabilidad, compromiso, comportamiento ético</li>
        </ul>
      </div>

      <!-- TAB 2 -->
      <div id="tab2" class="tab-pane fade">

        <ul>
       <li>1. Integra los procesos gerenciales, de administración, de innovación y las estrategias para alcanzar la productividad y competitividad de las organizaciones. </li>
       <li>2. Adapta las etapas de los procesos a las nuevas tendencias y enfoques de la administración, para la optimización de los recursos y el manejo de los cambios organizacionales, de acuerdo a las necesidades del entorno.   </li>
       <li>3. Desarrolla habilidades directivas basadas en la ética y la responsabilidad social, que le permitan integrar y coordinar equipos interdisciplinarios y multidisciplinarios para el crecimiento de la organización. </li>
       <li>4. Crea y desarrolla proyectos sustentables aplicando métodos de investigación de vanguardia, con un enfoque estratégico, multicultural y humanista.</li>
       <li>5. Dirige la organización hacia la consecución de sus objetivos, a través de la coordinación de esfuerzos y el desarrollo creativo.   </li>
       <li>6. Diseña organizaciones que contribuyan a la transformación económica y social identificando las oportunidades de negocios. </li>
       <li>7. Interpreta y aplica el marco legal vigente nacional e internacional, para dar certeza jurídica a las organizaciones.   </li>
       <li>8. Interpreta información financiera y económica para la toma de decisiones en las organizaciones.  </li>
       <li>9. Desarrolla el capital humano a través de la utilización de técnicas y herramientas gerenciales para la toma de decisiones.  </li>
       <li>10. Implementa y administra sistemas de gestión de calidad para orientarlos a la mejora continua, con la finalidad de lograr la eficacia y eficiencia de la organización. </li>
       <li>11. Aplica las tecnologías de la información y comunicación en el diseño de estrategias que optimicen el trabajo y desarrollo de las organizaciones. </li>
       <li>12. Posee una visión multidisciplinaria para generar acciones ante escenarios de contingencia salvaguardando la integridad humana. </li>
       <li>13. Diseña estrategias de mercadotecnia basadas en el análisis de la información interna y del entorno global, para asegurar el éxito de la comercialización de bienes y servicios de las organizaciones. </li>
        </ul>
      </div>


        <div id="tab3" class="tab-pane fade">
        <ul>
           <h5>"Programa Acreditado por el Consejo de Acreditación de Ciencias Administrativas, Contables y Afines, A.C. con vigencia hasta Abril de 2028"

</h5>
            <br>
           <div class="tab-image-wrapper">
            
          <img src="assets/banners_carreras/caceca.png" alt="Información de la carrera" class="tab-image">
        </div>
        </ul>
       

          </div>

     
     <!--  <div id="tab4" class="tab-pane fade">
        
        <ul>
          <li>Identifica, formula y resuelve problemas de ingeniería computacional aplicando los principios de las ciencias básicas e ingeniería.</li>
          <li>Aplica metodologías para el análisis y diseño de soluciones tecnológicas que cumplen las necesidades especificadas.</li>
          <li>Desarrolla y conduce proyectos de tecnología computacional y/o científicos para analizar e interpretar datos y utilizar el juicio ingenieril para la toma de decisiones y análisis de resultados.</li>
          <li>Comunica y colabora efectivamente con equipos multidisciplinarios que le permitan analizar, planificar y desarrollar proyectos de tecnología computacional</li>
          <li>Reconoce sus responsabilidades éticas y profesionales al generar soluciones computacionales, en el contexto global, económico, ambiental y social.</li>
          <li>Reconoce la necesidad de actualización en tendencias del ámbito tecnológico que le permita tener la habilidad para localizar, evaluar, integrar y aplicar este conocimiento adecuadamente</li>
          <li>Dirige y/o participa en equipos de trabajo para analizar, planear, gestionar, y ejecutar tareas para el cumplimiento de metas de proyectos de tecnología computacional.</li>
        </ul>
      </div> 


           <div id="tab5" class="tab-pane fade">
              <h5>"Programa Acreditado por el Consejo de Acreditación de la Enseñanza de la Ingeniería con vigencia hasta Diciembre de 2028"</h5>
            <br>
           <div class="tab-image-wrapper">
            
          <img src="assets/banners_carreras/logo cacei.jpg" alt="Información de la carrera" class="tab-image">

     </div>  -->

    </div>

  </div>

  <!--DOCUMENTACIÓN -->
  <div class="doc-section text-center">
    <img src="assets/banners_carreras/logo_drive.png" class="doc-icon">
    <br>
    <a href="https://drive.google.com/drive/folders/1DZLQcl_Cm0lYIRR7gndruRU1ngM6TvWk" target="_blank"
      class="doc-link">
      ■ DOCUMENTACIÓN LICENCIATURA EN ADMINISTRACIÓN 
    </a>
  </div>

  <hr>


  <div class="btn-section">
    
    <a href="assets/reticulas/reticula_admin_mixta.jpeg" target="_blank" class="btn-doc">
      📊 Retícula
    </a>
  </div>

  <!-- CONTACTO  -->
  <section class="contact-section">

    <div class="contact-row">

      <div class="contact-card">
        <h3>■ JEFA DE DIVISIÓN</h3>
        <p class="name">Mtra. Geni del Carmen Gómez Xul</p>
        <p>E-mail: <a href="mailto:divisionif@itsescarcega.edu.mx">divisionla@itsescarcega.edu.mx</a></p>
        <P> Telefono:9821055060 </P>
      </div>
      
     <div class="contact-card">
        <h3>■ COORDINADORA</h3>
        <p class="name">LC. Lorena del Carmen Cruz Barrientos</p>
        <p>E-mail: <a href="mailto:coordinacionisc@itsescarcega.edu.mx">coordinacionla@itsescarcega.edu.mx</a></p>
        <!-- <p> Telefono:9828291780</p> -->
      </div>  

    </div>

  </section>

</div>